
<!-- Navbar ends here -->

<!-- Main content multiple tabs -->
<div *ngIf="showOEMMessage && !showPublishedMessage" class="oem_message_section">
<span class="round-info-icon" alt="info-message"></span>
<span class="oem-message">{{publishedOEMMsg}}</span>
</div>
<div class="content__wrapper">
    <!-- Tab-links -->
    <ul *ngIf="showPartnerContent && !showView && !showAttractorView && !isCreateNewAttrEnable" class="nav nav-tabs" role="tablist">
        <li class="nav-item">
            <a class="nav-link active gtmOemEnterModelInfo" data-toggle="tab" [routerLink]="modelSkuInfo"
                [ngClass]="{'active': tabIndex === 0}">{{modelSkuInfoTab}}</a>
        </li>
        <li class="nav-item" placement="right" 
        [ngbPopover]="disableAttractorLoop ? contentGroupToolTip:''"
        container="body"  triggers="mouseenter:mouseleave">
            <a class="nav-link gtmOemCreatePartnerContent" data-toggle="tab" [routerLink]="createPartner"
                [ngClass]="{'active': tabIndex === 1, 'inActive': disableCreatePartner}">{{createpartnerContentTab}}</a>
        </li>
        <li class="nav-item" placement="right"
        [ngbPopover]="disableAttractorLoop ? attractorLoopToolTip:''"
        container="body"  triggers="mouseenter:mouseleave">
            <a class="nav-link" data-toggle="tab" [routerLink]="attractorLoop"
                [ngClass]="{'active': tabIndex === 2 ,'inActive': disableAttractorLoop}">{{attractorLoopTab}}</a>
        </li>
    </ul>
    <div id="" class="tab-content" *ngIf="!showView && !showAttractorView && !isCreateNewAttrEnable">
        <div id="modelSkuInfo" *ngIf="tabIndex === 0" class="tab-pane" [ngClass]="{'active': tabIndex === 0}">
            <iposcen-model-sku-info (isModelSkuPresent)="disableCreatePartners($event)"></iposcen-model-sku-info>
        </div>
        <div id="createPartnerContent" *ngIf="tabIndex === 1" [ngClass]="{'active': tabIndex === 1}">
            <iposcen-create-partner-content #forCreateEdit (autoID)="autoID= $event" (contentID)="contentId = $event" (viewOn)="showView = $event" (showAuthorTabs)="showTabs($event)"
            (isNewPartnerContent)= "isNewPartnerContent=  $event">
            </iposcen-create-partner-content>
        </div>
        <div id="attractorLoopOem" *ngIf="tabIndex === 2" class="tab-pane" [ngClass]="{'active': tabIndex === 2}">
            <iposcen-attractor-loop-oem (editOnChange)='isCreateNewAttrEnable = $event' (isEditON)='isCreateAttrInEditMode = $event' (sendDataOemPortal)='createAttractLoopData($event)' (attractorViewOn)="showAttractorView = $event" (attractorLoopId)="attractorLoopId = $event" (attractorLoopEnabled)="disableAttractorLoops($event)"></iposcen-attractor-loop-oem>
        </div>
        <router-outlet></router-outlet>
    </div>
    <div id="showView" *ngIf="showView" class="tab-pane">
        <iposcen-view [contentId]="contentId" (emitEditData)="sendEditData($event)"  [autoID] = "autoID" (viewOn)="showView = $event"></iposcen-view>
    </div>

    <div id="showAttractorView" *ngIf="showAttractorView" class="tab-pane">
        <iposcen-view-attract-admin (disableAttrLoop) = 'isCreateNewAttrEnable = false' (isEditON)='isCreateAttrInEditMode = $event; isCreateNewAttrEnable = true; showAttractorView = false' [getSelectedList] = 'selectList' [attractorLoopId]="attractorLoopId" [adminRef] = "adminRef" (attractorViewOn) = "showAttractorView = $event"></iposcen-view-attract-admin>
    </div>
    <div id="createAttractorLoopOem" *ngIf='isCreateNewAttrEnable'>
        <iposcen-create-attractor-loop-oem [inEditMode]='isCreateAttrInEditMode' [getSelectedList]='selectList' (goToAttrDashBoard)='isCreateNewAttrEnable=false;' ></iposcen-create-attractor-loop-oem>
    </div>
</div>